import { cn } from "@/lib/utils";

interface LoadingScreenProps {
  className?: string;
}

export function LoadingScreen({ className }: LoadingScreenProps) {
  return (
    <div
      className={cn("min-h-screen flex items-center justify-center", className)}
      style={{ background: "transparent" }}
    >
      <div
        className="w-10 h-10 rounded-full animate-spin"
        style={{ border: "2.5px solid var(--c-brand-tint-strong)", borderTopColor: "var(--primary)" }}
        aria-label="Yuklanmoqda"
      />
    </div>
  );
}
